const TOPICS = [
  { id: 1, label: '流浪地球3', heat: '爆', count: '128万讨论' },
  { id: 2, label: '暑期档推荐', heat: '热', count: '96万讨论' },
  { id: 3, label: '周星驰经典', heat: '热', count: '83万讨论' },
  { id: 4, label: '诺兰电影宇宙', heat: '热', count: '71万讨论' },
  { id: 5, label: '豆瓣高分合集', heat: '新', count: '65万讨论' },
  { id: 6, label: '4K修复老片', heat: '热', count: '58万讨论' },
  { id: 7, label: '悬疑片推荐', heat: '', count: '52万讨论' },
  { id: 8, label: '漫威观影顺序', heat: '', count: '47万讨论' },
  { id: 9, label: '奥斯卡获奖', heat: '新', count: '41万讨论' },
  { id: 10, label: '日韩电影精选', heat: '', count: '38万讨论' },
];

export default function TopicsSection() {
  const heatStyle: Record<string, string> = {
    '爆': 'bg-accent-500 text-foreground-950',
    '热': 'bg-primary-500 text-background-50',
    '新': 'bg-green-500 text-foreground-950',
  };

  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            影迷们正在热烈讨论的电影话题，加入讨论发现更多值得看的国内外大片
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {TOPICS.map((topic) => (
            <div
              key={topic.id}
              className="group cursor-pointer"
            >
              <div className="flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 border border-background-200/30 hover:border-primary-500/20 hover:bg-background-100/80 transition-all duration-300">
                <span className="text-sm text-foreground-700 group-hover:text-foreground-900 whitespace-nowrap">
                  #{topic.label}
                </span>
                {topic.heat && (
                  <span className={`px-1.5 py-0.5 rounded text-[10px] font-bold leading-none ${heatStyle[topic.heat] || ''}`}>
                    {topic.heat}
                  </span>
                )}
                <span className="text-[11px] text-foreground-400 whitespace-nowrap">{topic.count}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}